import { useOutletContext } from 'react-router-dom';
import InvoiceMonthList from 'components/invoiceList/InvoiceMonthList';
import InvoiceSelectionBar from 'components/invoiceList/InvoiceSelectionBar';

const InvoiceContent = () => {
  const {
    monthInvoices,
    onSelectInvoiceMonth,
    onClearInvoiceFilters,
    period,
    invoiceSelection,
    onRetryInvoices,
    isInvoiceImportRunning,
    invoiceImportBanner,
  } = useOutletContext();

  // One scroll for the whole tab, not one in the table: the import banner,
  // which carries its own margin, goes up with the list, the head of the table
  // sticks to the top and its footer to the bottom (InvoiceMonthList). The display choice is in the header,
  // next to the status. The selection bar, outside the scroll, floats over the
  // bottom.
  return (
    <div className="relative flex flex-col flex-1 min-h-0">
      <div className="flex-1 min-h-0 overflow-auto thin-scrollbar">
        <div className="min-h-full flex flex-col">
          {invoiceImportBanner}
          <InvoiceMonthList
            {...monthInvoices}
            period={period}
            onSelectMonth={onSelectInvoiceMonth}
            onClearFilters={onClearInvoiceFilters}
            selection={invoiceSelection}
          />
        </div>
      </div>
      <InvoiceSelectionBar
        period={period}
        numbers={invoiceSelection.numbers}
        errorNumbers={invoiceSelection.errorNumbers}
        statuses={invoiceSelection.statuses}
        onRetry={onRetryInvoices}
        isImportRunning={isInvoiceImportRunning}
      />
    </div>
  );
};

export default InvoiceContent;
